import { AddContactFormModalContextProvider, AddExpenseFormModalContextProvider, AddInsuranceFormModalContextProvider, AddUnityFormModalContextProvider, ShowGalleryPictureModalContextProvider } from "@/contexts"
import { usePropertyDetailContext, useUserLanguage } from "@/customHooks"
import { InventoryFormModalContextProvider } from "@/contexts/InventoryFormModalContextProvider"
import { PropertyDetailContractsList, PropertyDetailExpensesList, PropertyDetailInventoriesList, PropertyDetailNotesList, PropertyDetailOverview, PropertyDetailTenantsList, PropertyDetailUnitsList, PropertyUpdateForm } from "../organism"
import { PropertyDetailIncidentsList } from "../organism/PropertyDetailIncidentsList"
import { AddExpenseFormModal } from "./AddExpenseFormModal"
import { InventoryFormModal } from "./InventoryFormModal"
import { AddUnitFormModal } from "./AddUnitFormModal"
import type { InventorySectionConfig, PropertyCommonsProps } from "@/custom-types"
import textsData from "@/textData/PropertyDetailTexts.json"

type PropertyDetailTemplateProps = {
  selectedSection: string
}

export const PropertyDetailTemplate = ({ selectedSection }: PropertyDetailTemplateProps) => {
  const { property } = usePropertyDetailContext()
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const inventorySectionsConfig: InventorySectionConfig[] = []

  if (property) {
    const commons: PropertyCommonsProps = {
      balcony: property.balcony ?? false,
      patio: property.patio ?? false,
      commonBathroom: property.commonBathroom ?? false,
      kitchen: property.kitchen ?? false,
      elevator: property.elevator ?? false,
      commonAirConditioner: property.commonAirConditioner ?? false,
      commonFan: property.commonFan ?? false,
    }

    const areaDefinitions: { key: keyof PropertyCommonsProps; id: string; title: string; matchTerms: string[] }[] = [
      { key: 'kitchen', id: 'cocina', title: texts.areas.kitchen, matchTerms: ['cocina', 'kitchen'] },
      { key: 'patio', id: 'patio', title: texts.areas.patio, matchTerms: ['patio'] },
      { key: 'balcony', id: 'balcon', title: texts.areas.balcony, matchTerms: ['balcon', 'balcón', 'balcony'] },
      { key: 'commonBathroom', id: 'bano-compartido', title: texts.areas.commonBathroom, matchTerms: ['baño compartido', 'bano compartido', 'shared bathroom'] },
      { key: 'elevator', id: 'ascensor', title: texts.areas.elevator, matchTerms: ['ascensor', 'elevator'] },
      { key: 'commonAirConditioner', id: 'aire-comun', title: texts.areas.commonAirConditioner, matchTerms: ['aire acondicionado común', 'aire acondicionado comun', 'shared air conditioner'] },
      { key: 'commonFan', id: 'ventilador-comun', title: texts.areas.commonFan, matchTerms: ['ventilación común', 'ventilacion comun', 'shared fan'] },
    ]

    areaDefinitions.forEach(({ key, id, title, matchTerms }) => {
      if (commons[key]) {
        inventorySectionsConfig.push({
          id,
          title,
          matcher: (item) => {
            const normalizedDescription = item.description.toLowerCase()
            return matchTerms.some((term) => normalizedDescription.includes(term.toLowerCase()))
          },
        })
      }
    })
  }

  return (
    <>
      {
        (
          () => {
            switch(selectedSection) {
              case '1':
                return (
                  <AddInsuranceFormModalContextProvider>
                    <AddContactFormModalContextProvider>
                      <ShowGalleryPictureModalContextProvider>
                        <PropertyDetailOverview />
                      </ShowGalleryPictureModalContextProvider>
                    </AddContactFormModalContextProvider>
                  </AddInsuranceFormModalContextProvider>
                )
              
              case '2':
                return <PropertyDetailTenantsList />

              case '3':
                return (
                  <InventoryFormModalContextProvider>
                    <PropertyDetailInventoriesList />
                    <InventoryFormModal sectionsConfig={inventorySectionsConfig} />
                  </InventoryFormModalContextProvider>
                )

              case '4':
                return (
                  <AddUnityFormModalContextProvider>
                    <PropertyDetailUnitsList />
                    <AddUnitFormModal />
                  </AddUnityFormModalContextProvider>
                )

              case '5':
                return (
                  <AddExpenseFormModalContextProvider>
                    <PropertyDetailExpensesList />
                    <AddExpenseFormModal />
                  </AddExpenseFormModalContextProvider>
                )

              case '6':
                return <PropertyDetailIncidentsList />

              case '7':
                return <PropertyDetailContractsList />
            
              case '8':
                return <p>Soy seccion 8</p>

              case '9':
                return <PropertyDetailNotesList />

              case '10':
                return <PropertyUpdateForm />

              default:
                console.warn('invalid option')
            }
          }
        )()
      }
    </>
  )
}